module.exports = __webpack_public_path__ + "img/cen_03.22a0e96c.gif";